import { ajax } from '@/api/ajax';
import type { XDragonApiResponsePromise } from '@/api/ajax';

export interface UsageReq {
  /**
   * 图例编码
   */
  legendCode?: string;
  /**
   * 车型编码
   */
  modelCode?: string;
  /**
   * 备件编码
   */
  partNo?: string;
  /**
   * 车架号
   */
  vin?: string;
  /**
   * 只返回直送的备件：1-是，0-否
   */
  directPart?: number;
}

export interface UsageResp {
  /**
   * 图例编码
   */
  legendCode?: string;
  /**
   * 图例名称
   */
  legendName?: string;
  /**
   * 图例SVG图片ID
   */
  legendSvgFileId?: string;
  /**
   * 备件信息列表
   */
  partList?: Part[];
}
export interface Part {
  /**
   * 标号（对应SVG图例的数字）
   */
  callout?: number;
  /**
   * 用法备注
   */
  note?: string;
  /**
   * 备件名称
   */
  partName?: string;
  /**
   * 备件编码
   */
  partNo?: string;
  /**
   * 缩略图文件ID
   */
  photoFileId?: string;
  /**
   * 备件图片数量0~6
   */
  photoQty?: number;
  /**
   * 缩略图地址URL
   */
  photoUrl?: string;
  /**
   * 价格展示：0-隐藏，1-展示
   */
  priceDisplay?: number;
  /**
   * 数量
   */
  qty?: number;
  /**
   * 零售价
   */
  salePrice?: number;
  /**
   * 销售状态：0-停售 1-正常
   */
  saleState?: number;
  /**
   * 是否装车件：0-否 1-是
   */
  vinLoadingPart?: number;
}

/**
 * @operationId usageUsingPOST
 * @tags EPC目录查询
 * @logan http://logan-gateway.test.logan.xiaopeng.local/xp-ass-epc-cn-boot/doc.html#/EPC-%E7%9B%AE%E5%BD%95%E6%9F%A5%E8%AF%A2/EPC%E7%9B%AE%E5%BD%95%E6%9F%A5%E8%AF%A2/usageUsingPOST
 */
export function usageUsingPost(data: UsageReq): XDragonApiResponsePromise<UsageResp> {
  return ajax({
    url: '/api/tis/web/epc/catalog/usage',
    method: 'post',
    data: data
  });
}
